import { render, staticRenderFns } from "./metas-onboarding-modal.vue?vue&type=template&id=ddb0d118&scoped=true"
import script from "./metas-onboarding-modal.vue?vue&type=script&lang=js"
export * from "./metas-onboarding-modal.vue?vue&type=script&lang=js"
import style0 from "./metas-onboarding-modal.vue?vue&type=style&index=0&id=ddb0d118&prod&scoped=true&lang=css"
import style1 from "./metas-onboarding-modal.vue?vue&type=style&index=1&id=ddb0d118&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb0d118",
  null
  
)

export default component.exports